module.exports = __webpack_public_path__ + "static/view_3-ca001bff94ac66de7c65280817eabbec.jpg";